import React from 'react';
import {classes, st} from '../../../common/components/Layout/Layout.st.css';
import {MainLoader} from '../../../common/components/Layout/MainLoader/MainLoader';
import {AsideLoader} from '../../../common/components/Layout/AsideLoader/AsideLoader';
import {HeaderLoader} from '../../../common/components/Layout/HeaderLoader/HeaderLoader';
import {A11yIds, SPECS} from '../../../common/constants';
import {useEnvironment, useExperiments} from '@wix/yoshi-flow-editor';
import {Spinner} from '@wix/wix-ui-tpa/cssVars';

export enum LoadingLayoutDataHooks {
  root = 'LoadingLayoutDataHooks.root',
  mainSection = 'LoadingLayoutDataHooks.mainSection',
  oneColumnViewSummary = 'LoadingLayoutDataHooks.oneColumnViewSummary',
  twoColumnViewSummary = 'LoadingLayoutDataHooks.twoColumnViewSummary',
  verticalDivider = 'LoadingLayoutDataHooks.verticalDivider',
  spinner = 'LoadingLayoutDataHooks.spinner',
}

export interface LoadingLayoutProps {
  isOneColumnView?: boolean;
}

export const LoadingLayout = ({isOneColumnView}: LoadingLayoutProps) => {
  const {isEditor} = useEnvironment();
  const {experiments} = useExperiments();
  const ecomFitCheckoutLayoutOnTablet = experiments.enabled(SPECS.ecomFitCheckoutLayoutOnTablet);
  const asideClassName = ecomFitCheckoutLayoutOnTablet ? classes.aside : /* istanbul ignore next */ classes.asideOld;
  const summaryContainerClassName = ecomFitCheckoutLayoutOnTablet
    ? classes.summaryContainer
    : /* istanbul ignore next */ classes.summaryContainerOld;

  if (isEditor) {
    return (
      <div className={classes.spinnerContainer}>
        <Spinner data-hook={LoadingLayoutDataHooks.spinner} isCentered={true} />
      </div>
    );
  }

  return (
    <div data-hook={LoadingLayoutDataHooks.root} className={st(classes.root, classes.loadingRoot)}>
      <HeaderLoader />
      <div className={st(classes.mainContainer, classes.loadingMainContainer)}>
        <div className={classes.container}>
          {isOneColumnView && (
            <div className={st(summaryContainerClassName, classes.loadingSummaryContainer)}>
              <aside
                data-hook={LoadingLayoutDataHooks.oneColumnViewSummary}
                className={st(asideClassName, classes.loadingAside)}
              />
            </div>
          )}
          <div className={classes.formContainer}>
            <section className={classes.main} data-hook={LoadingLayoutDataHooks.mainSection}>
              <MainLoader />
            </section>
          </div>
          {!isOneColumnView && <div data-hook={LoadingLayoutDataHooks.verticalDivider} className={classes.divider} />}
          <div className={st(summaryContainerClassName, classes.loadingSummaryContainer)}>
            <section
              aria-labelledby={A11yIds.SummarySection}
              data-hook={LoadingLayoutDataHooks.twoColumnViewSummary}
              className={st(asideClassName, classes.loadingAside)}>
              <AsideLoader />
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};
